import React from 'react';
// Style
import './OfferItem.scss';

function OfferItem(props) {
  const {
    item: { marketPrice, offerLabel, productImage, productName, productPrice, currencyCode },
    currencyMark,
    dataLocale: { UNLOCK_OFFER },
  } = props;
  return (
    <div className="offer-product-container mr-b10 pd-l20 pd-r20 pd-t30">
      <div className="offer-title text-center fw500 fsp18 mr-b15 text-color_3c">{UNLOCK_OFFER}</div>
      <div className="display-flex display-flex align-items-center offer-info pd-b30">
        <div className="product-image pd-r10 pos-rel">
          <img alt="" src={productImage} />
        </div>
        <div className="p-info fsp14 lh-20">
          <div className="text-color_3c mr-b5 fsp14 fw400">{productName}</div>
          <div className="offer-text fsp12">
            <span className="text-topaz fw700 pd-r4">
              {offerLabel} {currencyMark[currencyCode]}
              {productPrice}
            </span>
            {marketPrice > productPrice && (
              <span className="text-color_cc strike-through">
                {currencyMark[currencyCode]}
                {marketPrice}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfferItem;
